var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.447 142.388L604.928 142.388C748.113 142.388 864.188 249.843 864.188 382.395L864.188 550.399C864.188 682.952 748.113 790.406 604.928 790.406L423.447 790.406C280.262 790.406 164.188 682.952 164.188 550.399L164.188 382.395C164.188 249.843 280.262 142.388 423.447 142.388Z",
    fill: "#4788c7",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.884 877.489C469.884 877.489 660.899 662.53 516.399 610.072C435.924 580.857 842.227 521.866 806.943 581.183C750.595 675.912 779.746 733.802 695.633 783.919C612.581 833.404 469.884 877.489 469.884 877.489Z",
    fill: "#4788c7",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.41 186.798L591.965 186.798C714.695 186.798 814.188 278.902 814.188 392.519L814.188 536.523C814.188 650.139 714.695 742.243 591.965 742.243L436.41 742.243C313.68 742.243 214.188 650.139 214.188 536.523L214.188 392.519C214.188 278.902 313.68 186.798 436.41 186.798Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#TextBounds)",
    d: "M510.69 557.298C531.044 557.298 541.221 545.026 544.214 525.271C546.608 498.033 556.186 483.666 595.397 460.918C636.104 436.673 658.852 405.245 658.852 359.45C658.852 291.804 603.179 245.71 522.064 245.71C460.405 245.71 413.712 270.852 395.154 311.559C389.467 322.933 386.773 334.008 386.773 346.878C386.773 366.933 399.045 379.504 419.698 379.504C436.16 379.504 447.235 372.021 453.82 353.463C463.398 323.232 485.548 306.77 518.772 306.77C555.588 306.77 581.03 329.518 581.03 362.144C581.03 390.878 568.458 407.34 531.343 429.789C493.929 451.939 475.371 476.482 475.371 513.598L475.371 519.285C475.371 541.135 487.942 557.298 510.69 557.298ZM511.289 687.201C535.534 687.201 554.69 668.344 554.69 644.698C554.69 621.052 535.534 602.495 511.289 602.495C487.044 602.495 467.589 621.052 467.589 644.698C467.589 668.344 487.044 687.201 511.289 687.201Z",
    fill: "#4788c7",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelper);
export default __webpack_public_path__ + "static/media/Helper.dad214f2c1c5130a91b968b8cc8f05dd.svg";
export { ForwardRef as ReactComponent };